export default __webpack_public_path__ + "static/media/footer1.6e0f3047.jpg";